var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColony(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 436.5246,
    height: 342.6957,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 436.5246 342.6957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient-3);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{mix-blend-mode:screen;}.cls-19{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_84);}.cls-19,.cls-20,.cls-2,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31,.cls-32,.cls-33,.cls-34,.cls-35,.cls-4,.cls-36,.cls-37,.cls-6,.cls-38,.cls-7,.cls-39,.cls-40,.cls-8,.cls-41,.cls-9,.cls-42,.cls-43,.cls-44,.cls-45,.cls-46,.cls-47,.cls-10,.cls-11,.cls-48,.cls-49,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-58,.cls-59,.cls-60,.cls-61,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-67,.cls-68,.cls-69,.cls-70,.cls-71,.cls-72,.cls-73,.cls-14,.cls-74,.cls-75,.cls-76,.cls-77,.cls-78,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-88,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99,.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105{fill-rule:evenodd;}.cls-20{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_81-3);}.cls-2{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-2);}.cls-3{fill:url(#radial-gradient);}.cls-21{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_119-2);}.cls-22,.cls-25,.cls-37,.cls-54,.cls-57,.cls-72,.cls-77,.cls-78,.cls-85{mix-blend-mode:soft-light;}.cls-22,.cls-106,.cls-71,.cls-72{opacity:.2;}.cls-22,.cls-37{fill:#ecdedd;}.cls-107{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_133);}.cls-23{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-9);}.cls-108{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_133-3);}.cls-24{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_114);}.cls-25{opacity:.91;}.cls-25,.cls-78,.cls-85{fill:#ecaba4;}.cls-26{fill:#fff;}.cls-27{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-2);}.cls-28{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-3);}.cls-29{fill:#ff6890;}.cls-30{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-2);}.cls-31{fill:#2d153d;}.cls-32,.cls-109{fill:#66619c;}.cls-33{fill:#220816;}.cls-34,.cls-37,.cls-7,.cls-40,.cls-9,.cls-11,.cls-49,.cls-50,.cls-14,.cls-78,.cls-89{opacity:.5;}.cls-34,.cls-56{fill:#1d0c27;}.cls-110{isolation:isolate;}.cls-35{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-12);}.cls-4{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206);}.cls-36{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-15);}.cls-5{fill:url(#radial-gradient-5);}.cls-6{fill:url(#linear-gradient-2);}.cls-38{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-5);}.cls-7{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_130-3);}.cls-39{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-8);}.cls-40,.cls-47,.cls-49,.cls-50,.cls-71,.cls-89{mix-blend-mode:multiply;}.cls-40,.cls-47,.cls-71,.cls-72{fill:#ae9aff;}.cls-8{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_206-3);}.cls-41{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_122);}.cls-9{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_130);}.cls-42{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-9);}.cls-43{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_177);}.cls-44{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-6);}.cls-45{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-6);}.cls-46{fill:#402f65;}.cls-47{opacity:.36;}.cls-10{fill:url(#linear-gradient);}.cls-11{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_130-2);}.cls-48{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_119-4);}.cls-49{fill:#b3a9be;}.cls-50{fill:#ae799a;}.cls-51{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_119-3);}.cls-12{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_184);}.cls-52{fill:#401738;}.cls-53{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-7);}.cls-54{fill:#66181a;}.cls-54,.cls-57{opacity:.32;}.cls-55{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_84-2);}.cls-56{opacity:.6;}.cls-57{fill:#29004a;}.cls-58{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-6);}.cls-59{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-16);}.cls-60{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-5);}.cls-61{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-7);}.cls-62{fill:#47fff2;}.cls-63{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-5);}.cls-64,.cls-111{fill:#2a102c;}.cls-65{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-3);}.cls-66{fill:#db9f9c;}.cls-67{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_81);}.cls-13{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_184-2);}.cls-68{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-14);}.cls-69{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-4);}.cls-70{fill:#48163a;}.cls-73{fill:#479cf2;}.cls-14{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_130-4);}.cls-74{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_133-4);}.cls-75{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_122-4);}.cls-76{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-3);}.cls-77{fill:#f4ceca;}.cls-79{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-2);}.cls-112{fill:#471737;}.cls-15{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_184-3);}.cls-80{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80);}.cls-81{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_122-2);}.cls-82{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-4);}.cls-83{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-10);}.cls-16{fill:url(#radial-gradient-2);}.cls-17{fill:url(#radial-gradient-4);}.cls-84{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-11);}.cls-86{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-8);}.cls-18{fill:url(#radial-gradient-6);}.cls-87{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-4);}.cls-88{fill:#624e8f;}.cls-89{fill:#68134a;}.cls-90{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-7);}.cls-91{fill:#331732;}.cls-92{fill:#160122;}.cls-93{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115);}.cls-94{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-8);}.cls-95{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_80-9);}.cls-96{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_122-3);}.cls-97{fill:#a45754;}.cls-98{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_81-2);}.cls-99{fill:#69264d;}.cls-100{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_133-2);}.cls-101{fill:#ff9390;}.cls-102{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2-10);}.cls-103{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_119);}.cls-104{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_2);}.cls-105{fill:url(#_\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_115-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_177",
    x1: 192.1899,
    y1: 342.6957,
    x2: 192.1899,
    y2: 301.5079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f1d4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3771,
    stopColor: "#652e4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c3559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_114",
    x1: 311.6791,
    y1: 308.1894,
    x2: 311.6791,
    y2: 122.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#733152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f1d4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_84",
    x1: 93.4335,
    y1: 336.631,
    x2: 93.4335,
    y2: 33.1643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c214a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f1d4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_84-2",
    x1: 208.0641,
    y1: 331.7,
    x2: 208.0641,
    y2: 0,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_84"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 214.5146,
    cy: -163.2445,
    fx: 214.5146,
    fy: -163.2445,
    r: 49.3861,
    gradientTransform: "translate(-132.3143 235.6018) scale(1.6231 .6382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3300b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2337,
    stopColor: "#3300b3",
    stopOpacity: 0.6946
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    stopColor: "#3300b3",
    stopOpacity: 0.3977
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7127,
    stopColor: "#3300b3",
    stopOpacity: 0.1813
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#3300b3",
    stopOpacity: 0.0487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3300b3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 214.5146,
    cy: -163.2445,
    fx: 214.5146,
    fy: -163.2445,
    r: 28.7538,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 259.1568,
    cy: -1496.6318,
    fx: 259.1568,
    fy: -1496.6318,
    r: 58.3368,
    gradientTransform: "translate(-751.2941 497.6632) scale(3.7412 .2436)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1f29c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0296,
    stopColor: "#1f29c9",
    stopOpacity: 0.9597
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#1f29c9",
    stopOpacity: 0.6219
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5313,
    stopColor: "#1f29c9",
    stopOpacity: 0.3544
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7359,
    stopColor: "#1f29c9",
    stopOpacity: 0.1616
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8989,
    stopColor: "#1f29c9",
    stopOpacity: 0.0434
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f29c9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 213.8501,
    cy: -1496.6318,
    fx: 213.8501,
    fy: -1496.6318,
    r: 29.5261,
    gradientTransform: "translate(-959.0893 497.6632) scale(5.5055 .2436)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 213.7402,
    cy: -1968.1528,
    fx: 213.7402,
    fy: -1968.1528,
    r: 17.2397,
    gradientTransform: "translate(-1482.6391 525.927) scale(7.9578 .1996)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 234.61,
    cy: 176.2548,
    fx: 234.61,
    fy: 176.2548,
    r: 14.0842,
    gradientTransform: "translate(48.5484 -140.7267) scale(.822 1.2723)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80",
    x1: 313.3171,
    y1: 328.6512,
    x2: 313.3171,
    y2: 328.6412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#220936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593155"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-2",
    x1: 308.784,
    y1: 330.0386,
    x2: 308.784,
    y2: 298.6683,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133",
    x1: 308.7888,
    y1: 325.2701,
    x2: 308.7888,
    y2: 303.4359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#220e38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#220936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2",
    x1: 293.2046,
    y1: 301.1775,
    x2: 306.9727,
    y2: 301.1775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#593155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#220936"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119",
    x1: 312.7298,
    y1: 305.1526,
    x2: 312.7298,
    y2: 299.7463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#220936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#402249"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115",
    x1: 314.4715,
    y1: 307.8658,
    x2: 318.9197,
    y2: 307.8658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#220936"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#250e36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-2",
    x1: 311.1278,
    y1: 325.9231,
    x2: 315.5527,
    y2: 325.9231,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-3",
    y1: 320.6382,
    x2: 318.3707,
    y2: 320.6382,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-4",
    x1: 315.8921,
    y1: 314.3684,
    x2: 319.7681,
    y2: 314.3684,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122",
    x1: 308.789,
    y1: 324.4925,
    x2: 308.789,
    y2: 304.2111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9abb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666d9a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-2",
    x1: 304.9352,
    y1: 319.4655,
    x2: 304.9352,
    y2: 309.5826,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130",
    x1: 306.5281,
    y1: 323.3062,
    x2: 309.0766,
    y2: 318.8921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_81",
    x1: 310.1789,
    y1: 319.3287,
    x2: 310.1789,
    y2: 309.3928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e58b95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-3",
    x1: 314.0634,
    y1: 333.058,
    x2: 314.0634,
    y2: 333.0508,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-4",
    x1: 310.8005,
    y1: 334.0567,
    x2: 310.8005,
    y2: 311.4758,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133-2",
    x1: 310.8039,
    y1: 330.6243,
    x2: 310.8039,
    y2: 314.9076,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-3",
    x1: 299.5861,
    y1: 313.2819,
    x2: 309.4966,
    y2: 313.2819,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119-2",
    x1: 313.6407,
    y1: 316.1433,
    x2: 313.6407,
    y2: 312.2517,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-5",
    x1: 314.8944,
    y1: 318.0963,
    x2: 318.0963,
    y2: 318.0963,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-6",
    x1: 312.4876,
    y1: 331.0943,
    x2: 315.6727,
    y2: 331.0943,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-7",
    x1: 314.8944,
    y1: 327.2901,
    x2: 317.7011,
    y2: 327.2901,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-8",
    x1: 315.9171,
    y1: 322.777,
    x2: 318.7071,
    y2: 322.777,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122-2",
    x1: 310.8041,
    y1: 330.0645,
    x2: 310.8041,
    y2: 315.4656,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-4",
    x1: 308.03,
    y1: 326.446,
    x2: 308.03,
    y2: 319.3321,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130-2",
    x1: 309.1767,
    y1: 329.2106,
    x2: 311.0111,
    y2: 326.0333,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_81-2",
    x1: 346.5652,
    y1: 310.6133,
    x2: 346.5652,
    y2: 296.8099,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-5",
    x1: 351.9618,
    y1: 329.6866,
    x2: 351.9618,
    y2: 329.6766,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-6",
    x1: 347.4287,
    y1: 331.074,
    x2: 347.4287,
    y2: 299.7037,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133-3",
    x1: 347.4335,
    y1: 326.3055,
    x2: 347.4335,
    y2: 304.4713,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-5",
    x1: 331.8493,
    y1: 302.2129,
    x2: 345.6174,
    y2: 302.2129,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119-3",
    x1: 351.3746,
    y1: 306.188,
    x2: 351.3746,
    y2: 300.7817,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-9",
    x1: 353.1162,
    y1: 308.9012,
    x2: 357.5644,
    y2: 308.9012,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-10",
    x1: 349.7726,
    y1: 326.9585,
    x2: 354.1975,
    y2: 326.9585,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-11",
    x1: 353.1162,
    y1: 321.6735,
    x2: 357.0155,
    y2: 321.6735,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-12",
    x1: 354.5368,
    y1: 315.4038,
    x2: 358.4128,
    y2: 315.4038,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122-3",
    x1: 347.4337,
    y1: 325.5279,
    x2: 347.4337,
    y2: 305.2465,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-6",
    x1: 343.5799,
    y1: 320.5009,
    x2: 343.5799,
    y2: 310.618,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130-3",
    x1: 345.1729,
    y1: 324.3416,
    x2: 347.7213,
    y2: 319.9276,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_81-3",
    x1: 278.2218,
    y1: 317.8308,
    x2: 278.2218,
    y2: 307.8948,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_81"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-7",
    x1: 282.1063,
    y1: 331.5601,
    x2: 282.1063,
    y2: 331.5529,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-8",
    x1: 278.8434,
    y1: 332.5587,
    x2: 278.8434,
    y2: 309.9779,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133-4",
    x1: 278.8468,
    y1: 329.1263,
    x2: 278.8468,
    y2: 313.4096,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_133"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-7",
    x1: 267.6291,
    y1: 311.784,
    x2: 277.5395,
    y2: 311.784,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119-4",
    x1: 281.6837,
    y1: 314.6454,
    x2: 281.6837,
    y2: 310.7538,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_119"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-13",
    x1: 282.9373,
    y1: 316.5984,
    x2: 286.1392,
    y2: 316.5984,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-14",
    x1: 280.5305,
    y1: 329.5964,
    x2: 283.7156,
    y2: 329.5964,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-15",
    x1: 282.9373,
    y1: 325.7922,
    x2: 285.7441,
    y2: 325.7922,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115-16",
    x1: 283.9599,
    y1: 321.2791,
    x2: 286.7499,
    y2: 321.2791,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_115"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122-4",
    x1: 278.847,
    y1: 328.5666,
    x2: 278.847,
    y2: 313.9677,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-8",
    x1: 276.0729,
    y1: 324.948,
    x2: 276.0729,
    y2: 317.8341,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130-4",
    x1: 277.2196,
    y1: 327.7127,
    x2: 279.054,
    y2: 324.5353,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_130"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80-9",
    x1: 311.9339,
    y1: 293.5091,
    x2: 311.9339,
    y2: 289.1577,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_80"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-9",
    x1: 303.4678,
    y1: 302.0027,
    x2: 303.4678,
    y2: 296.8582,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2-10",
    x1: 379.2833,
    y1: 408.1947,
    x2: 379.2833,
    y2: 403.0502,
    gradientTransform: "translate(-177.8498 -12.6191) rotate(-12.7855)",
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_184",
    cx: 251.7831,
    cy: 99.7313,
    fx: 251.7831,
    fy: 99.7313,
    r: 12.545,
    gradientTransform: "translate(37.4152 235.6018) scale(1.0548 .6382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3300b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2337,
    stopColor: "#23007c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    stopColor: "#140047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7127,
    stopColor: "#090020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#020008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206",
    cx: 251.7831,
    cy: 99.7312,
    fx: 251.7831,
    fy: 99.7312,
    r: 7.304,
    gradientTransform: "translate(37.4152 235.6018) scale(1.0548 .6382)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a40b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2337,
    stopColor: "#122c7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4901,
    stopColor: "#0a1947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7127,
    stopColor: "#040b20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#010308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_184-2",
    cx: 231.9945,
    cy: 98.8193,
    fx: 231.9945,
    fy: 98.8193,
    r: 12.545,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-2",
    cx: 231.9946,
    cy: 98.8194,
    fx: 231.9946,
    fy: 98.8194,
    r: 7.304,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_184-3",
    cx: 257.4606,
    cy: 87.3262,
    fx: 257.4606,
    fy: 87.3262,
    r: 9.0378,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_184"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206-3",
    cx: 257.4606,
    cy: 87.3262,
    fx: 257.4606,
    fy: 87.3262,
    r: 5.2621,
    xlinkHref: "#_\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_206"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 302.6108,
    y1: 321.111,
    x2: 436.5246,
    y2: 321.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#633631"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2172,
    stopColor: "#633631",
    stopOpacity: 0.7152
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5576,
    stopColor: "#633631",
    stopOpacity: 0.3274
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8306,
    stopColor: "#633631",
    stopOpacity: 0.088
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#633631",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 303.6613,
    y1: 322.9312,
    x2: 411.6951,
    y2: 322.9312,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "space_background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M3.5516,335.6154s14.4782-1.9821,14.0869,0-10.9565,7.0803-10.9565,7.0803l34.0435-2.7504,153.9546,2.3042-.4818-3.0939,103.2772,3.0939-2.4777-5.1357,32.0002,1.6772s-12.8787,3.0123-8.9017,3.4585c3.9771,.4462,62.7318-4.2645,62.7318-4.2645l-11.2604-16.3887s8.8535,.7516,7.6795-2.7759c-1.1739-3.5274-41.4081-17.3126-41.4081-17.3126l-236.4135,9.2841-78.2921,5.8064-17.5818,19.0171Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "160.5019 337.9113 307.7762 337.038 304.886 338.791 213.8082 338.791 200.393 341.8733 113.5266 342.2495 160.5019 337.9113"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "255.6645 334.1123 277.6048 330.8144 385.1183 331.5968 369.7644 335.4816 255.6645 334.1123"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "313.5841 205.8695 301.9808 216.5794 307.7824 240.3615 309.8008 241.8428 310.4441 245.1594 289.9841 237.0794 278.4545 220.751 281.6441 187.7826 296.6441 185.4141 313.5841 205.8695"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M385.2241,292.6594l-5.31-1.52-8.08,2.15-32.46-19.33-5.69-21.35-5.11-4.1-14.97-6.63-6.07-39.79,6.05,3.78,3.18,12.51,1.61,.97,4.13,21.3,1.05-.29-9.45-46.86-7.51-27.41-16.87-20.84-11.3817-22.9902-12.7878,10.4853,3.5195,30.6949-.95,2.27,4.93,34.74,6.95,78.56-13.39-19.7-7.4951-.8006-20.0749,18.3625-12.66,31.3181,51.22-2.27,43.07-2.73,23.85-1.52,52.45-3.33-11.75-5.68Zm-95.24-55.58l-2.4-10.61-4.17-3.03-1.77-15.54,16.29-14.53,4.05,14.66h1.26l7.2,37.13-20.46-8.08Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "369.1841 294.6794 342.4041 287.2594 344.5241 301.6694 344.6741 302.6694 324.2009 303.113 311.6741 246.7994 305.0741 210.0494 278.3423 122.2592 289.7241 145.2494 306.5941 166.0894 314.1041 193.4994 323.5541 240.3594 322.5041 240.6494 318.3741 219.3494 316.7641 218.3794 313.5841 205.8695 307.5341 202.0894 313.6041 241.8794 328.5741 248.5094 333.6841 252.6094 339.3741 273.9595 371.8341 293.2895 369.1841 294.6794"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "311.2718 208.0037 315.3703 219.2644 317.6491 220.1178 321.6783 240.6494 322.5041 240.6494 316.5072 209.5405 313.5841 205.8695 311.2718 208.0037"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "307.7824 240.3615 289.9841 237.0794 310.4441 245.1594 309.8008 241.8428 307.7824 240.3615"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "287.5841 226.4694 304.7837 228.0692 307.7824 240.3615 289.9841 237.0794 287.5841 226.4694"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "259.1189 258.5089 259.1189 276.8713 265.4756 304.6544 268.5072 304.6544 280.0041 279.0094 266.6141 259.3094 259.1189 258.5089"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "309.5549 177.1919 292.7815 169.959 292.8811 169.7296 309.6545 176.9624 309.5549 177.1919"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "272.9016 198.9253 272.7454 198.7299 295.9661 180.2954 296.1223 180.4917 272.9016 198.9253"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 268.829,
    y: 180.4052,
    width: 27.368,
    height: 0.2497,
    transform: "translate(-52.3399 197.2094) rotate(-35.4308)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "278.3313 194.4204 276.4711 184.7505 276.7171 184.7036 278.5774 194.3736 278.3313 194.4204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "269.1594 163.5312 268.9895 163.3476 286.0618 147.5752 286.1301 147.5957 293.7112 149.8891 293.6389 150.1284 286.1262 147.8554 269.1594 163.5312"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "276.5081 242.2075 276.4221 241.9731 289.9407 236.9624 290.0266 237.1967 276.5081 242.2075"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "286.1926 177.8549 281.5208 151.8481 281.7669 151.8042 286.4387 177.811 286.1926 177.8549"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 277.2792,
    y: 261.8557,
    width: 37.866,
    height: 0.2507,
    transform: "translate(-85.5605 158.9019) rotate(-26.3811)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "280.0706 279.1157 279.9378 278.9028 314.0784 257.6079 314.1233 257.6137 335.8391 260.5112 335.8059 260.7592 314.1351 257.8677 280.0706 279.1157"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 270.824,
    y: 293.0535,
    width: 50.5518,
    height: 0.2494,
    transform: "translate(-53.5228 66.479) rotate(-11.7561)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "300.0961 304.6958 296.0941 293.2193 296.3303 293.1372 300.3323 304.6137 300.0961 304.6958"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 293.17,
    y: 263.6532,
    width: 0.2494,
    height: 6.764,
    transform: "translate(-40.1068 52.1561) rotate(-9.5148)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "298.0969 267.646 298.0881 260.9917 298.3381 260.9917 298.3469 267.646 298.0969 267.646"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "278.3423 122.2592 297.6832 185.7772 296.0193 186.6773 284.4339 152.6994 281.3746 154.677 286.3159 182.4165 284.1277 185.3097 275.5771 134.4657 271.3506 136.3286 275.0124 160.5299 269.8966 166.3405 265.5545 132.7445 278.3423 122.2592"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "294.9365 239.0352 310.4441 245.1594 304.1471 212.6861 305.0741 210.0494 312.6356 251.1223 324.2009 303.113 316.8879 303.4294 309.6046 252.2983 305.8335 250.3394 309.6046 279.7095 302.8019 279.7095 294.9365 239.0352"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "286.3159 288.0445 272.8239 182.4165 276.4651 175.5962 289.9841 284.5336 286.3159 288.0445"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "313.5841 245.7939 333.6841 252.6094 337.6914 267.6457 331.4124 266.4264 335.8231 288.0445 328.7598 289.8794 324.2009 256.7394 320.8489 255.2967 322.5041 270.3705 318.9072 270.9299 313.5841 245.7939"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "289.7241 145.2494 283.9799 141.6773 299.7438 192.5444 301.2181 192.5444 294.6545 165.5194 296.0193 165.7089 304.6966 193.9899 314.8166 197.0328 314.1041 193.4994 306.5941 166.0894 289.7241 145.2494"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "339.3741 273.9595 339.3741 283.372 342.4041 287.2594 344.6741 302.6694 370.8229 300.7394 369.1841 294.6794 345.2378 288.0445 339.8441 283.1352 339.3741 273.9595"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "293.8537 289.8794 293.8537 283.9405 294.9365 289.4826 293.8537 289.8794"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "294.9365 283.5141 294.9365 280.4826 296.2123 279.7095 296.0998 282.9457 294.9365 283.5141"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "285.0545 198.8276 284.4339 195.2036 285.0545 193.9899 286.3159 197.7299 285.0545 198.8276"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "286.3159 167.2247 286.3159 170.7594 287.6441 170.7594 286.7598 167.2247 286.3159 167.2247"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M128.6756,234.1258l9.4736-11.9368,4.1685-14.9685-8.5263-17.2421,1.1368-13.9684-2.0842-3.8421,17.0526-123.5369-13.0105-15.4667-13.7745,5.0755-19.9027,84.8222,1.0877,3.8848-1.7684,8.8421-4.1684,.8842-4.5474,6.4421,2.4905,4.3079-1.4078-2.4351-11.5057,43.8321,.8305-.5647-2.5338,1.723-31.8316,121.2632-6.4421,1.6894-6.4421,23.7,78.8211-4.9263,24.7579-20.4631-10.5474-13.4527-2.6527-1.8947-1.5157-19.3263-4.1685-7.3895,4.9264-35.0526h2.0842Zm-37.5158-50.5895l-6.492,4.4146,2.7499-11.1883,.9474-.7526,7.9585-28.5511,2.1625,3.7406-7.3263,32.3368Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "136.8861 33.1643 121.0966 121.3889 122.6124 125.81 112.3353 185.0163 99.9869 190.9655 90.0229 238.2942 121.0966 237.73 82.8229 240.25 66.5282 314.9 68.9914 321.85 74.8651 320.46 82.0651 303.66 119.3914 276.5679 126.5914 234.1258 120.1493 228.63 119.3914 215.2241 131.3282 200.3995 133.7914 189.9784 134.9282 176.01 132.8441 172.1679 149.8966 48.631 136.8861 33.1643"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "142.3177 207.2205 137.7703 210.3774 127.4124 212.9638 123.6229 213.773 133.7441 200.7311 134.2795 190.9655 142.3177 207.2205"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "128.6756 234.1258 123.6229 228.63 123.6229 216.6311 137.7703 210.3774 142.3177 207.2205 138.1492 222.189 128.6756 234.1258"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "125.8335 276.5679 120.8124 289.7679 119.9598 294.9468 113.6441 299.7468 106.6941 331.7 128.3827 320.46 126.4019 305.1784 127.3492 295.8942 125.8335 276.5679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "130.0019 297.7889 127.3966 305.6521 128.6993 320.2959 137.3941 315.79 140.5541 311.24 130.0019 297.7889"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "111.7524 300.338 102.3387 303.28 82.0651 303.66 119.6441 277.7679 121.6651 269.1784 125.8335 276.5679 120.3387 287.4513 111.7524 300.338"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "103.2089 123.062 121.0966 121.3889 123.6229 125.81 136.8861 130.9239 122.3282 126.0784 104.2966 126.9468 103.2089 123.062"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "93.8124 143.1152 95.2651 144.25 94.8951 144.988 93.8124 143.1152"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "96.3236 147.4589 97.0335 144.988 100.3808 144.988 98.4861 151.1995 96.3236 147.4589"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "43.4124 312.931 49.0966 320.2959 69.5598 333.2205 49.8545 311.2416 43.4124 312.931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "99.9869 190.9655 81.6861 189.9784 91.1598 183.5363 112.3353 185.0163 99.9869 190.9655"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "142.0999 104.3196 126.0603 93.6228 109.4691 96.8303 109.3743 96.3391 126.1668 93.0925 142.3772 103.9036 142.0999 104.3196"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 137.9342,
    y: 64.3689,
    width: 0.4999,
    height: 17.9902,
    transform: "translate(2.9982 152.1162) rotate(-58.1873)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 123.5568,
    y: 86.1062,
    width: 26.1668,
    height: 0.4996,
    transform: "translate(34.852 211.9229) rotate(-83.2635)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "147.5721 64.5413 145.5662 62.9534 147.2073 45.7063 147.7053 45.7541 146.0896 62.7297 147.8826 64.1496 147.5721 64.5413"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 94.0341,
    y: 64.9467,
    width: 60.659,
    height: 0.4997,
    transform: "translate(35.2447 173.7079) rotate(-78.2696)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 114.8016,
    y: 71.3918,
    width: 8.6606,
    height: 0.5005,
    transform: "translate(-15.5389 37.1635) rotate(-16.6609)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 104.5625,
    y: 107.8286,
    width: 28.1149,
    height: 0.4995,
    transform: "translate(-10.1845 203.7916) rotate(-78.9533)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 63.5523,
    y: 182.7429,
    width: 111.188,
    height: 0.4999,
    transform: "translate(-81.943 268.1125) rotate(-79.8745)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "97.2586 156.9792 97.2078 156.4822 117.2278 154.4211 123.8861 156.4919 123.7376 156.9695 117.1771 154.9289 97.2586 156.9792"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 127.1032,
    y: 164.0092,
    width: 0.4998,
    height: 11.8541,
    transform: "translate(-78.0262 223.9411) rotate(-67.884)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 107.3923,
    y: 188.5166,
    width: 0.4993,
    height: 17.6441,
    transform: "translate(-103.0582 275.6634) rotate(-81.7809)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 79.9005,
    y: 217.2948,
    width: 41.9662,
    height: 0.4997,
    transform: "translate(-131.4918 276.7465) rotate(-79.4142)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 73.7092,
    y: 278.7401,
    width: 45.8107,
    height: 0.5008,
    transform: "translate(-28.8266 11.718) rotate(-6.0415)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 65.9691,
    y: 249.6018,
    width: 14.7578,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "54.7391 316.4739 54.2517 316.3625 69.3162 249.7961 69.8035 249.9075 54.7391 316.4739"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 57.1325,
    y: 299.2428,
    width: 12.819,
    height: 0.5004,
    transform: "translate(-11.6231 2.7038) rotate(-2.2334)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 52.3226,
    y: 219.8792,
    width: 60.9878,
    height: 0.4999,
    transform: "translate(-150.2329 251.8055) rotate(-77.1231)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 75.7175,
    y: 212.4651,
    width: 8.7989,
    height: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "82.0651 303.66 68.9914 321.85 71.2651 331.7 49.8545 311.2416 69.5598 333.2205 69.9465 334.57 106.6941 331.7 111.1438 311.2416 102.3387 303.28 82.0651 303.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "43.4124 312.931 49.0966 320.2959 43.4124 336.2284 65.9692 334.8186 36.9703 336.631 43.4124 312.931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "82.8229 240.25 70.6908 295.83 76.7569 294.4416 89.6311 248.9679 91.4124 248.9679 84.5164 286.4192 87.2441 286.4192 95.7072 245.43 109.4215 243.2315 103.9493 281.4129 119.6441 277.7679 126.0848 237.73 82.8229 240.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "134.9282 176.01 117.5383 170.6868 108.2124 217.1495 115.4361 217.1495 123.8121 183.5363 127.3531 183.5363 124.3177 196.0778 132.8441 196.0778 133.9151 188.46 134.9282 176.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "136.8861 33.1643 122.8147 111.7889 126.9703 115.1363 136.8861 53.8433 138.1842 56.0687 130.5403 108.0786 135.0959 111.7889 142.2383 56.0687 143.7387 57.0626 142.2383 68.6221 146.7777 71.2256 149.8966 48.631 136.8861 33.1643"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "135.0959 156.7307 126.4019 153.9784 130.7489 128.8812 138.4688 131.4192 135.0959 156.7307"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "121.0966 121.3889 136.8861 33.1643 126.4793 36.9989 114.9829 87.2837 117.5914 86.356 125.9345 46.3574 130.5403 45.73 118.1866 121.6611 121.0966 121.3889"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "122.3282 126.0784 112.3353 185.0163 97.0107 183.9452 104.7568 143.3708 106.6941 143.3708 100.3808 180.8837 103.2089 180.7574 111.3703 128.2561 109.6695 128.2561 107.2019 141.3468 105.5598 141.2837 107.5193 126.7916 122.3282 126.0784"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "99.9869 190.9655 90.0229 238.2942 86.4229 238.2942 93.4335 200.8732 88.8861 200.7784 73.8378 273.855 68.9914 274.8 85.8545 190.4069 99.9869 190.9655"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "66.5282 314.9 73.4619 283.1351 65.9692 283.1351 59.8019 314.9 66.5282 314.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "90.1539 297.7889 93.4335 283.1351 101.8966 283.1351 99.9869 290.652 90.1539 297.7889"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "61.8719 265.4611 66.0274 265.4611 59.3831 294.821 53.3858 297.7889 61.8719 265.4611"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "57.1375 315.6626 61.3206 307.078 57.7493 316.7995 57.1375 315.6626"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "70.0808 282.3468 71.5019 276.5679 70.7914 280.9258 70.0808 282.3468"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "78.0362 224.0837 77.8896 218.8122 77.1407 220.1295 78.0362 224.0837"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "74.7387 235.5153 75.7808 234.3468 74.7387 239.81 74.7387 235.5153"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "133.7441 200.7311 142.3177 207.2205 134.2795 190.9655 133.7441 200.7311"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "106.8647 122.72 110.1554 126.6647 116.4873 126.3597 113.5601 122.0938 106.8647 122.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "121.9037 123.0997 119.7387 126.1564 122.3282 126.0784 124.0962 126.6669 124.9607 126.3258 123.6229 125.81 121.9037 123.0997"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "250.1941 243.41 228.7177 247.8311 221.0761 253.24 221.8966 289.7679 226.3841 303.28 240.2756 312.9311 230.5491 321.6626 182.4861 321.6626 182.4861 255.7258 209.3914 206.4626 245.9598 230.7153 250.1941 243.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "190.8441 271.09 221.0761 253.24 221.8966 289.7679 226.3841 303.28 240.2756 312.9311 230.5491 321.6626 184.2651 320.46 190.8441 271.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M302.0441,321.85l-21.41-3.6-5.31-12.5-10.61-2.09-5.23,1.28-.7-6.33-5.06-48.76,2.03-2.27-9.6-103.33h3.03l-3.79-40.17,2.78-2.78,.5-23.24-.5-6.06-5.56-16.67-6.06-3.79-1.77-25.77-3.92-8.97h-1.39l-5.63-5.43-.81-4.3-3.79-7.07-10.303,3.7175-.877,22.0525-14.59,4.55-.76-7.08-10.73,6.7-1.77,30.82-2.15,3.28-1.64,45.98-1.9,27.16,3.04,4.55-1.9,18.94,.63,5.18-2.27,32.21-3.16,30.57-5.05,1.26-7.08,15.54,.38,2.02,6.95,8.47-4.67,6.82-5.06,22.23-12.25,14.15-3.53,12.12-3.16,4.55-30.7,15.91h117.15l8.85-1.32,76.74-2.84-7.39-5.69Zm-69.66-5.68l-2.28-1.27-11.49,1.27-5.56-3.2389v3.4089l-13.01,4.12-13.01-2.9,3.464-42.2498-1.064-8.6602,2.15-6.76,10.99-12.43,7.7-2.28,.6813,16.4332,4.4987,4.4073,2.65-28.2905,13.71-3.84,5.45,2.32,2.32,42.82,3.15,4.42,1.14,26.78-11.49,5.94Zm24-16.93l-2.78-3.41-3.29,7.45-.56,4.42-2.72,1.65-3.16-47.18,2.57-21.92,3.75,3.16,3.53,36.88,2.66,4.17v14.78Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "192.7141 23.24 200.0437 28.2712 193.4741 30.32 192.7141 23.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "219.2441 0 219.5139 129.2858 223.8408 131.4681 223.1244 215.5706 225.4335 211.67 226.3861 159.4732 231.2848 155.1589 232.3646 156.1037 232.8861 232.7995 242.4897 237.9153 247.0341 309.35 243.8741 262.1679 246.7177 237.9153 255.7541 247.58 246.3329 146.1758 249.1841 144.25 245.3941 104.08 237.4991 75.2837 237.4991 52.131 236.5541 51.54 234.7841 25.77 230.8641 16.8 229.4741 16.8 223.8441 11.37 223.0341 7.07 219.2441 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "242.6141 55.33 239.0441 67.7679 239.0441 75.5363 245.2966 100.1679 248.1741 101.3 248.6741 78.06 248.1741 72 242.6141 55.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "233.4417 22.9709 220.1453 12.6731 208.3661 19.9343 208.2351 19.7214 220.1619 12.3694 220.2302 12.4226 233.5941 22.7737 233.4417 22.9709"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 179.8095,
    y: 57.7948,
    width: 18.6181,
    height: 0.5002,
    transform: "translate(-8.7065 57.518) rotate(-16.9099)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "176.5339 108.7414 176.4226 108.2541 214.1941 99.5896 214.1941 36.5198 219.2151 31.9944 219.3738 32.0915 236.0608 42.2517 235.8011 42.6785 219.2727 32.6155 214.6941 36.7424 214.6941 99.988 176.5339 108.7414"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 214.1886,
    y: 76.9284,
    width: 5.311,
    height: 0.5002,
    transform: "translate(-12.1814 100.0959) rotate(-25.3058)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "214.5837 88.2493 214.3044 87.8342 219.4504 84.3723 240.7346 86.7385 240.6799 87.2356 219.5774 84.8899 214.5837 88.2493"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 195.3503,
    y: 56.0686,
    width: 0.5,
    height: 48.043
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 197.7727,
    y: 49.6413,
    width: 0.5,
    height: 8.4039
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 180.9877,
    y: 32.9145,
    width: 13.1341,
    height: 0.4997,
    transform: "translate(4.1839 84.6596) rotate(-25.7138)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 173.8372,
    y: 124.1345,
    width: 46.4966,
    height: 0.5,
    transform: "translate(-28.4087 65.5069) rotate(-17.6233)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 214.1941,
    y: 118.8738,
    width: 0.5,
    height: 12.0503
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 176.23,
    y: 144.8492,
    width: 41.8364,
    height: 0.4999,
    transform: "translate(-27.3593 47.5412) rotate(-12.8657)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "176.3386 166.0959 176.2498 165.6038 213.5941 158.885 213.5941 154.5124 217.2888 152.8684 217.2888 132.2493 217.7888 132.2493 217.7888 153.1936 214.0941 154.8376 214.0941 159.303 176.3386 166.0959"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "218.3538 237.7395 217.8538 237.72 221.6526 141.3205 223.7258 140.2107 223.9622 140.6511 222.1409 141.6262 218.3538 237.7395"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 174.2692,
    y: 188.6475,
    width: 17.0265,
    height: 0.4993,
    transform: "translate(-40.3569 49.9713) rotate(-14.0362)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 144.102,
    y: 209.2599,
    width: 92.8444,
    height: 0.5001,
    transform: "translate(-23.3855 395.0809) rotate(-88.6595)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 189.8814,
    y: 214.9739,
    width: 29.6812,
    height: 0.5009,
    transform: "translate(-45.6314 55.3626) rotate(-13.8726)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 190.1183,
    y: 206.4858,
    width: 29.8021,
    height: 0.4995,
    transform: "translate(-44.3091 56.3765) rotate(-14.1465)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "227.1555 189.7112 226.9309 189.2649 232.4602 186.4709 232.6848 186.9172 227.1555 189.7112"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 242.7989,
    y: 205.4884,
    width: 0.5004,
    height: 21.9065,
    transform: "translate(-43.1724 371.3516) rotate(-70.1092)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 196.6663,
    y: 208.7776,
    width: 0.5,
    height: 8.372
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "210.5237 245.1975 210.0247 245.1623 210.3836 240.0891 217.9939 236.3645 218.2136 236.8137 210.8621 240.4114 210.5237 245.1975"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 189.2725,
    y: 242.9819,
    width: 21.7667,
    height: 0.4996,
    transform: "translate(-58.9179 64.0535) rotate(-15.8808)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 185.1453,
    y: 138.9519,
    width: 0.5,
    height: 8.8384
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "165.8141 229.89 172.6335 236.5889 174.5241 233.89 170.8641 228.63 165.8141 229.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "158.7341 245.43 160.2466 248.4547 166.5703 252.8837 166.0641 255.92 159.1141 247.45 158.7341 245.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "161.3941 262.74 168.5914 265.7679 176.5493 266.9047 176.5493 279.0311 156.3341 284.97 161.3941 262.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "144.0841 299.12 164.5493 293.3047 177.6861 284.97 185.8966 311.2416 181.7282 312.9311 161.2651 322.8626 193.0745 321.6626 205.3493 323.9995 156.3341 330.38 198.6861 330.38 215.4541 329.5585 219.2441 331.7 106.6941 331.7 144.7177 328.7995 162.9691 325.01 140.5541 311.24 144.0841 299.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "275.3241 305.75 253.2229 311.2416 231.8887 320.46 280.6341 318.25 275.3241 305.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "302.0441 321.85 293.5177 324.6311 232.6941 330.38 309.4341 327.54 302.0441 321.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "190.4981 275.3102 187.0341 274.8 177.6861 284.97 185.8966 311.2416 187.5521 311.2416 190.4981 275.3102"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "215.4541 266.0205 214.1891 259.4521 214.1282 241.3258 217.9625 239.2411 215.4541 266.0205"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "214.1891 259.4521 210.9553 261.6132 215.4541 266.0205 214.1891 259.4521"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "253.6041 295.83 256.3841 299.24 256.3841 303.66 252.4966 302.4311 253.6041 295.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "161.3941 262.74 168.5914 265.7679 176.5493 266.9047 176.2941 258.1889 170.9877 250.675 166.0641 255.92 161.3941 262.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "189.4341 266.65 185.7072 266.81 185.3282 259.4521 191.5841 259.89 189.4341 266.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "185.7072 266.81 187.0341 274.8 190.4981 275.3102 189.4341 266.65 185.7072 266.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "226.3841 303.28 208.0641 308.335 219.8756 311.2416 239.5817 312.449 226.3841 303.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "213.0541 312.9311 214.5703 316.2311 222.4019 318.8205 218.6141 316.17 213.0541 312.9311"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "230.1041 314.9 227.9598 315.8758 226.3841 317.9363 232.3841 316.17 230.1041 314.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "280.6341 318.25 248.4203 319.7105 239.5817 329.729 293.5177 324.6311 300.9299 321.6626 280.6341 318.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "275.3241 305.75 253.2229 311.2416 249.7541 307.7 264.7141 303.66 275.3241 305.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "208.0641 305.75 217.7281 290.5889 221.8966 289.7679 226.3841 303.28 208.0641 305.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "250.1941 243.41 251.8335 246.2129 253.6603 279.6241 248.4201 243.7751 250.1941 243.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "254.4403 281.4129 256.3841 299.24 256.3841 284.46 254.4403 281.4129"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "232.5726 135.5984 232.8578 228.63 239.0441 233.89 235.8083 156.8837 239.0441 158.9047 243.8741 199.5784 251.6211 203.0943 246.1541 144.25 232.5726 135.5984"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "228.4651 126.9468 222.3286 42.4653 226.3841 43.9574 229.8079 114.7047 235.6066 117.2205 235.6066 99.0311 245.3941 104.08 249.1841 144.25 228.4651 126.9468"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "223.8441 11.37 229.8001 76.7508 235.7563 80.09 229.4741 16.8 223.8441 11.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "252.2608 214.355 240.7177 211.67 240.7177 214.355 252.9268 217.1495 252.2608 214.355"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "180.1177 140.0521 177.6861 232.6095 184.0921 230.6183 185.7072 158.6521 190.3132 156.6311 189.1185 206.4626 206.0424 203.0943 206.6441 133.1363 180.1177 140.0521"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "209.7106 135.7889 207.9021 242.1336 213.2047 239.2411 216.0453 165.85 219.2441 163.0997 220.9741 236.9261 222.3286 236.5889 223.8266 133.1363 209.7106 135.7889"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "219.2441 0 219.5139 129.2858 198.0229 134.9016 201.2514 58.045 204.4651 53.8433 206.6441 126.9468 216.2471 124.2311 211.8541 48.2521 206.6441 49.6416 208.0641 25.77 208.9411 3.7175 219.2441 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "180.2141 123.062 181.9841 29.94 192.7141 23.24 189.1185 120.06 180.2141 123.062"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "237.2641 236.21 242.4897 237.9153 232.5726 231.5363 218.8019 236.5889 217.9625 238.2942 230.5438 234.6582 237.2641 236.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "191.5841 259.89 185.3282 259.4521 200.1557 246.2129 210.2741 240.8845 210.3708 247.5139 202.8229 248.0205 191.5841 259.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "160.7746 265.4611 167.9988 269.1153 175.2229 278.4626 165.7493 271.9619 160.7746 265.4611"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "249.1841 144.25 219.4687 120.7321 204.7221 128.9609 179.3598 139.01 174.5241 137.18 177.5641 141.73 180.1177 140.0521 223.8266 133.1363 246.1541 144.25 249.1841 144.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "242.6141 55.33 239.0441 67.7679 239.0441 75.5363 245.2966 100.1679 248.1741 101.3 245.3941 104.08 237.4991 75.2837 237.4991 52.131 242.6141 55.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "190.2011 223.7078 201.9062 220.1679 200.1557 239.2411 189.6887 240.8845 190.2011 223.7078"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "174.5241 233.89 175.2229 247.7047 174.8735 253.24 170.9877 250.675 176.2941 258.1889 176.5493 279.0311 177.6861 217.1495 172.4834 212.9638 170.8641 228.63 174.5241 233.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "177.6861 130.5433 177.6861 134.9016 196.1282 130.5433 197.0855 124.3845 177.6861 130.5433"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "226.1406 172.9237 223.4877 172.9237 223.2691 198.5999 225.6911 197.5575 226.1406 172.9237"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "203.8966 234.9153 204.1808 231.5363 204.7221 231.0942 204.3093 234.9153 203.8966 234.9153"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "205.0195 237.73 205.4795 236.5889 206.2177 236.0679 206.2177 238.2942 205.0195 237.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "182.7823 264.0626 181.0966 259.89 182.4861 255.7258 182.7823 264.0626"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "194.6124 118.1679 193.7598 113.5258 194.6124 112.1047 195.6003 118.1679 194.6124 118.1679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "207.9021 78.315 209.7703 67.4508 210.5282 67.4508 207.9021 78.315"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "223.8266 133.1363 227.0031 126.6951 237.2252 134.7853 233.1484 137.7763 223.8266 133.1363"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "237.2252 139.8056 240.8259 137.6351 246.6361 142.1221 242.9776 142.6689 237.2252 139.8056"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "188.6744 138.6982 186.4641 136.1952 192.1651 133.9363 194.1983 137.8242 188.6744 138.6982"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "245.2966 100.1679 244.6318 101.3 237.4991 75.2837 239.0441 75.5363 245.2966 100.1679"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "237.4991 60.76 240.6243 62.2622 241.6593 58.6564 237.4991 56.0471 237.4991 60.76"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 215.8643,
    cy: 131.4192,
    rx: 80.155,
    ry: 31.5196
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 215.8643,
    cy: 131.4192,
    rx: 46.6683,
    ry: 18.3515
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 218.2623,
    cy: 133.0837,
    rx: 218.2623,
    ry: 14.21
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 218.2623,
    cy: 133.0837,
    rx: 162.5658,
    ry: 7.1921
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 218.2623,
    cy: 133.0837,
    rx: 137.2037,
    ry: 3.4407
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 241.3978,
    cy: 83.5223,
    rx: 11.577,
    ry: 17.9196
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M304.1944,314.3518c0,2.1991-.3161,4.2918-.8917,6.1915-.1297,.4392-.2761,.8684-.4358,1.2876-.9315,2.4486-2.3089,4.5047-3.9758,5.9453-.3726,.326-.7618,.6155-1.1611,.8717-1.3807,.8949-2.9111,1.3907-4.5247,1.3907-1.9862,0-3.8526-.752-5.4596-2.0728l.4159-.499v-.4225l-1.5803-.1764c-.9482-1.0247-1.78-2.2656-2.452-3.673l-.1531-.346,1.0248-.1497v-.702l-1.3508,.1065c-.6588-1.6502-1.1145-3.4867-1.3142-5.4397l.9482-.3992v-1.1212l-1.0513,.0965c-.01-.2961-.0166-.5889-.0166-.8883,0-8.6635,4.9206-15.6835,10.989-15.6835s10.9891,7.02,10.9891,15.6835Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M290.5974,329.591s9.0394,2.7683,19.9011,.2586l1.2755-30.5923s-10.5883-4.4653-21.1766-.1423v30.476Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M313.3104,328.6479c.0033,0,.0066-.0034,.0133-.0067-.0034,.0067-.0067,.01-.0133,.01v-.0033Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M318.9197,314.0656v.9682h.8483c-.0532,1.7467-.306,3.4168-.7252,4.9705l-.0699,.2496-.9682-.2496-.3693,1.4473,.7353,.5789c-.712,1.8165-1.6735,3.4101-2.818,4.6844l-1.5503-.7918-1.2044,.6021,.509,2.126c-1.3774,.8916-2.9078,1.3874-4.518,1.3874-6.0685,0-10.9891-7.0233-10.9891-15.6868s4.9206-15.6835,10.9891-15.6835c1.4139,0,2.768,.3826,4.009,1.078l-.2628,1.4306,1.0812,.3959,1.1312-.3959c1.4572,1.3408,2.6749,3.1606,3.5466,5.3065l-.7852,.702,.3926,1.1645,1.0181-.0832c.4957,1.6835,.7951,3.5166,.8483,5.4363v.0033l-.8483,.3593Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 308.7888,
    cy: 314.353,
    rx: 7.6479,
    ry: 10.9171
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "307.2053 324.2363 305.9278 329.4996 300.4748 329.4996 297.7301 328.6479 291.9843 326.8679 289.9382 328.3817 287.7457 327.9658 288.1616 327.4668 288.1616 327.0443 289.3561 327.1773 291.4786 325.0547 298.8911 327.7762 299.6298 328.049 303.3394 327.9725 306.4501 323.9302 307.2053 324.2363"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "303.7885 321.3119 302.8669 321.8309 299.8693 323.5143 297.1478 323.5842 290.1478 320.0642 287.7324 323.1949 284.1293 323.1949 283.9762 322.8489 285.0011 322.6992 285.0011 321.9972 286.8308 321.8542 289.8551 317.569 297.1412 321.5281 299.0874 321.5614 303.2029 320.3836 303.3027 320.5433 303.7885 321.3119"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "301.7557 315.7824 297.7999 316.3214 295.2714 316.4045 288.6507 311.953 285.3636 316.4045 282.3361 316.664 283.2842 316.2648 283.2842 315.1436 284.5318 315.0338 288.7738 308.7924 295.2714 314.5248 297.7999 314.3518 301.6858 314.3518 301.7557 315.7824"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "302.5213 309.5779 298.8384 307.6932 295.2701 307.2969 291.4769 302.0985 285.3636 305.8382 283.9758 305.8382 284.5817 304.6309 285.7379 304.5105 292.7604 299.6032 296.5091 305.8571 299.9002 305.1307 302.8472 308.794 302.5213 309.5779"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M306.9727,304.5037l-.3644-5.5271h-4.6585l.8974-1.6632s-3.8422-.2275-8.3895,.5875l-1.2531,.3187,8.4802-.3076-.823,1.6912h4.1798l.8851,5.4676,1.046-.5671Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "314.7476 301.1769 311.7733 305.1526 310.7121 304.5904 312.7981 299.7463 312.5352 301.1769 313.6164 301.5728 314.7476 301.1769"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "318.9197 308.2667 314.9273 309.2482 314.4715 308.2667 318.2942 306.4834 317.5091 307.1854 317.9016 308.3499 318.9197 308.2667"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "312.7981 326.5252 313.3071 328.6512 311.1278 323.9302 312.2657 323.1949 315.5527 326.7149 314.0024 325.9231 312.7981 326.5252"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "317.6354 321.4516 318.3707 322.0305 314.4715 320.4402 315.0504 319.2458 318.0047 320.0043 317.6354 321.4516"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "319.7681 313.703 319.7681 313.7063 318.9197 314.0656 318.9197 315.0338 315.8921 315.0338 315.8921 314.3518 319.7681 313.703"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M315.8921,314.3518c0,5.6026-3.1806,10.1407-7.1031,10.1407s-7.1032-4.5381-7.1032-10.1407c0-.0965,0-.193,.0067-.2895,.1031-5.4662,3.2405-9.8512,7.0965-9.8512,3.9225,0,7.1031,4.5413,7.1031,10.1407Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-109",
    cx: 308.7887,
    cy: 314.353,
    rx: 6.8505,
    ry: 9.7788
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M308.3969,314.524c0,2.7291-1.5499,4.9415-3.4617,4.9415s-3.4618-2.2124-3.4618-4.9415,1.5499-4.9414,3.4618-4.9414,3.4617,2.2123,3.4617,4.9414Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M303.4541,318.7854l2.2471,4.0087s3.9495,3.1294,7.6384-1.4407l-6.3669-2.8695s-1.046,1.206-3.5186,.3015Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M315.8921,314.3518s-2.1659-1.8132-7.1031-2.0095c-4.7909-.1897-6.9734,1.6102-7.0965,1.72,.1031-5.4662,3.2405-9.8512,7.0965-9.8512,3.9225,0,7.1031,4.5413,7.1031,10.1407Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M313.3103,328.6512c.0067,0,.01-.0033,.0134-.01-.0067,.0033-.01,.0067-.0134,.0067v.0033Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "307.2729 275.8252 311.6841 270.8986 326.0567 271.1178 322.8867 276.5841 307.2729 275.8252"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "326.0567 271.1178 331.9041 273.2727 332.8421 278.2574 322.8867 276.5841 326.0567 271.1178"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "274.6698 308.8122 278.8494 302.9409 275.9155 302.8096 281.7318 296.0635 286.7499 296.9715 278.5941 308.8704 274.6698 308.8122"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "284.3519 300.1701 278.8494 308.4094 281.3488 308.9815 286.7499 300.7134 284.3519 300.1701"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "275.9155 302.8096 277.6257 304.6598 278.8494 302.9409 275.9155 302.8096"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M319.2849,319.3287l-18.212-3.9182,4.8082-5.8079s11.1691-2.4956,13.4038,9.7261Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "333.3669 294.8007 329.7846 301.6921 318.3471 302.1531 320.2253 294.427 333.3669 294.8007"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "276.6593 291.8393 296.9451 275.8252 319.6215 275.8252 304.4541 292.5822 276.6593 291.8393"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "319.6215 275.8252 334.5644 278.3368 340.0556 286.273 340.2544 292.6937 304.4541 292.5822 319.6215 275.8252"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "276.6593 291.8393 281.5487 302.0489 305.9961 302.769 304.4541 292.5822 276.6593 291.8393"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "340.2544 292.6937 304.4541 292.5822 305.9961 302.769 317.8675 302.769 323.4023 295.6604 339.6564 294.258 340.2544 292.6937"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "308.3509 302.769 307.9386 297.6756 312.0862 295.4248 316.5432 297.6756 315.9345 302.769 308.3509 302.769"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M319.2849,324.4304h-8.122l-3.1329-13.99s5.4639-.1361,7.5234,1.0345c2.0596,1.1705,4.19,9.1837,3.7315,12.9555Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M307.4967,322.765c0,1.583-.2274,3.0894-.6418,4.4568-.0934,.3161-.1987,.6251-.3137,.9268-.6705,1.7626-1.662,3.2426-2.8618,4.2796-.2682,.2347-.5484,.443-.8358,.6274-.9939,.6442-2.0955,1.0011-3.257,1.0011-1.4297,0-2.7732-.5413-3.9299-1.492l.2994-.3592v-.3042l-1.1376-.1269c-.6825-.7376-1.2812-1.6309-1.765-2.6439l-.1101-.2491,.7376-.1077v-.5053l-.9723,.0766c-.4742-1.1878-.8023-2.5098-.946-3.9156l.6825-.2873v-.8071l-.7567,.0695c-.0072-.2132-.012-.4239-.012-.6395,0-6.2361,3.542-11.2892,7.9101-11.2892s7.9101,5.0531,7.9101,11.2892Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M297.7094,333.7345s6.5067,1.9927,14.3252,.1862l.9181-22.0209s-7.6216-3.2143-15.2433-.1024v21.9371Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M314.0586,333.0556c.0024,0,.0048-.0024,.0096-.0048-.0024,.0048-.0048,.0072-.0096,.0072v-.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M318.0963,322.5591v.6969h.6107c-.0384,1.2573-.2204,2.4595-.5221,3.5779-.0168,.0598-.0335,.1197-.0503,.1796l-.6969-.1796-.2658,1.0417,.5292,.4167c-.5125,1.3076-1.2046,2.4547-2.0284,3.3719l-1.116-.5699-.8669,.4334,.3664,1.5303c-.9915,.6418-2.0931,.9987-3.2522,.9987-4.3682,0-7.9101-5.0555-7.9101-11.2917s3.5419-11.2892,7.9101-11.2892c1.0178,0,1.9925,.2754,2.8858,.7759l-.1892,1.0298,.7783,.285,.8143-.285c1.0489,.9651,1.9254,2.2751,2.5529,3.8198l-.5652,.5053,.2826,.8382,.7328-.0599c.3568,1.2118,.5723,2.5313,.6107,3.9131v.0024l-.6107,.2587Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M316.3091,322.7659c0,4.3401-2.4648,7.8584-5.5052,7.8584s-5.5051-3.5183-5.5051-7.8584,2.4647-7.8583,5.5051-7.8583,5.5052,3.5183,5.5052,7.8583Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "309.6641 329.8801 308.7445 333.6687 304.8193 333.6687 302.8436 333.0556 298.7077 331.7744 297.2349 332.8641 295.6567 332.5647 295.9561 332.2055 295.9561 331.9013 296.8158 331.9971 298.3437 330.4692 303.6794 332.4282 304.2111 332.6246 306.8813 332.5695 309.1205 329.6598 309.6641 329.8801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "307.2046 327.775 306.5412 328.1486 304.3835 329.3604 302.4245 329.4107 297.3858 326.877 295.6471 329.1305 293.0535 329.1305 292.9434 328.8814 293.6811 328.7737 293.6811 328.2684 294.9981 328.1654 297.1751 325.0808 302.4197 327.9307 303.8207 327.9546 306.7831 327.1069 306.8549 327.2218 307.2046 327.775"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "305.7413 323.7948 302.8939 324.1828 301.0738 324.2427 296.3081 321.0384 293.9421 324.2427 291.7627 324.4294 292.4452 324.1421 292.4452 323.335 293.3433 323.256 296.3967 318.7633 301.0738 322.8896 302.8939 322.765 305.6911 322.765 305.7413 323.7948"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "306.2924 319.3287 303.6414 317.9721 301.0729 317.6868 298.3425 313.9449 293.9421 316.6368 292.9431 316.6368 293.3792 315.7678 294.2114 315.6811 299.2664 312.1487 301.9647 316.6504 304.4057 316.1275 306.5271 318.7645 306.2924 319.3287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M309.4966,315.6762l-.2623-3.9785h-3.3532l.646-1.1972s-2.7658-.1638-6.039,.4229l-.902,.2294,6.1042-.2214-.5924,1.2173h3.0087l.6371,3.9357,.7529-.4082Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "315.0932 313.2815 312.9522 316.1433 312.1882 315.7386 313.6898 312.2517 313.5006 313.2815 314.2789 313.5665 315.0932 313.2815"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "318.0963 318.3849 315.2225 319.0914 314.8944 318.3849 317.6461 317.1013 317.0809 317.6066 317.3635 318.4448 318.0963 318.3849"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "313.6898 331.5277 314.0562 333.058 312.4876 329.6598 313.3066 329.1305 315.6727 331.6642 314.5567 331.0943 313.6898 331.5277"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "317.1719 327.8756 317.7011 328.2923 314.8944 327.1476 315.3111 326.2878 317.4377 326.8339 317.1719 327.8756"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "318.7071 322.298 318.7071 322.3004 318.0963 322.5591 318.0963 323.256 315.9171 323.256 315.9171 322.765 318.7071 322.298"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M315.9171,322.765c0,4.0329-2.2895,7.2995-5.113,7.2995s-5.113-3.2666-5.113-7.2995c0-.0694,0-.1389,.0048-.2083,.0743-3.9347,2.3326-7.0911,5.1082-7.0911,2.8235,0,5.113,3.2689,5.113,7.2994Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M315.7351,322.7659c0,3.8875-2.2078,7.039-4.9312,7.039s-4.9311-3.1515-4.9311-7.039,2.2077-7.039,4.9311-7.039,4.9312,3.1515,4.9312,7.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M310.5218,322.889c0,1.9645-1.1156,3.557-2.4918,3.557s-2.4918-1.5925-2.4918-3.557,1.1156-3.5569,2.4918-3.5569,2.4918,1.5925,2.4918,3.5569Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "316.5432 297.6756 317.4712 302.1476 315.9173 306.7005 312.9527 306.7005 311.8652 309.9197 308.0301 309.3928 311.2147 304.4454 316.5432 297.6756"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M293.7675,309.3928s-3.8482,3.8999-3.9785,11.7003l8.9183-.4319s3.0958-8.8236,10.0364-11.7908c-5.3222-.1542-9.711-.1115-14.9762,.5224Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M308.7437,308.8704s5.0535,.5454,8.2267,2.6045c0,0,3.3926,4.9129,3.6521,12.9555h-1.3376s.0629-6.4061-3.3676-11.7945c0,0-2.619-1.836-7.1736-2.1955,0,0-6.3599,2.816-8.5372,11.1761l-1.4992-.9553s2.8475-9.1301,10.0364-11.7908Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "289.7891 321.0931 291.3257 321.9757 300.2065 321.6165 298.7073 320.6612 289.7891 321.0931"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "304.8195 308.8122 310.2568 299.0969 308.0301 298.8043 307.9386 297.6756 312.0862 295.4248 316.5432 297.6756 314.1658 304.2059 311.2147 304.4454 308.7437 308.8704 304.8195 308.8122"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "311.2147 304.4454 312.9527 306.7005 315.9173 306.7005 314.1658 304.2059 311.2147 304.4454"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M306.9639,325.9565l1.6175,2.8854s2.8429,2.2527,5.4983-1.0369l-4.5831-2.0656s-.7529,.8681-2.5327,.2171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M315.9171,322.765s-1.559-1.3051-5.113-1.4464c-3.4485-.1366-5.0195,1.1591-5.1082,1.2381,.0743-3.9347,2.3326-7.0911,5.1082-7.0911,2.8235,0,5.113,3.2689,5.113,7.2994Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M359.2156,310.6133l-25.3008-5.4434,6.6798-8.0685s15.5165-3.4669,18.621,13.5119Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M359.2156,317.7008h-11.2833l-4.3524-19.4355s7.5906-.189,10.4518,1.4372c2.8612,1.6261,5.8209,12.7583,5.1839,17.9983Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M342.8391,315.3872c0,2.1991-.316,4.2918-.8916,6.1915-.1298,.4392-.2761,.8684-.4359,1.2876-.9315,2.4486-2.3089,4.5047-3.9757,5.9453-.3726,.3261-.7619,.6155-1.1611,.8717-1.3807,.8949-2.9111,1.3907-4.5247,1.3907-1.9862,0-3.8527-.7519-5.4596-2.0727l.4158-.4991v-.4225l-1.5803-.1763c-.9482-1.0248-1.7799-2.2657-2.452-3.6731l-.153-.346,1.0247-.1497v-.702l-1.3508,.1065c-.6587-1.6502-1.1145-3.4867-1.3141-5.4397l.9482-.3992v-1.1212l-1.0514,.0965c-.01-.2961-.0166-.5889-.0166-.8883,0-8.6635,4.9206-15.6835,10.9891-15.6835s10.989,7.02,10.989,15.6835Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M329.2422,330.6264s9.0393,2.7683,19.9011,.2586l1.2755-30.5923s-10.5883-4.4653-21.1766-.1422v30.4759Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M351.9551,329.6833c.0033,0,.0066-.0033,.0133-.0067-.0033,.0067-.0067,.01-.0133,.01v-.0033Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M357.5644,315.1011v.9681h.8484c-.0532,1.7467-.3061,3.4168-.7253,4.9706-.0233,.0831-.0466,.1663-.0699,.2495l-.9681-.2495-.3693,1.4472,.7353,.5789c-.712,1.8165-1.6735,3.4102-2.818,4.6844l-1.5504-.7918-1.2044,.6022,.5091,2.1259c-1.3774,.8916-2.9078,1.3874-4.5181,1.3874-6.0684,0-10.9891-7.0233-10.9891-15.6868s4.9207-15.6835,10.9891-15.6835c1.414,0,2.7681,.3826,4.009,1.078l-.2628,1.4306,1.0813,.3959,1.1312-.3959c1.4572,1.3408,2.6748,3.1606,3.5465,5.3065l-.7851,.702,.3925,1.1645,1.0181-.0832c.4957,1.6835,.7952,3.5166,.8484,5.4363v.0034l-.8484,.3593Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 347.4335,
    cy: 315.3884,
    rx: 7.6479,
    ry: 10.9171
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "345.8501 325.2717 344.5725 330.535 339.1195 330.535 336.3748 329.6833 330.6291 327.9034 328.5831 329.4171 326.3905 329.0013 326.8063 328.5022 326.8063 328.0797 328.0007 328.2128 330.1234 326.0901 337.5359 328.8116 338.2745 329.0844 341.9841 329.0079 345.0948 324.9656 345.8501 325.2717"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "342.4332 322.3473 341.5116 322.8663 338.5141 324.5497 335.7926 324.6196 328.7926 321.0996 326.3772 324.2303 322.7741 324.2303 322.6211 323.8843 323.6457 323.7346 323.6457 323.0326 325.4755 322.8896 328.4998 318.6044 335.7859 322.5635 337.7322 322.5968 341.8477 321.419 341.9475 321.5787 342.4332 322.3473"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "340.4004 316.8178 336.4446 317.3568 333.9161 317.4399 327.2954 312.9884 324.0083 317.4399 320.9808 317.6994 321.9291 317.3002 321.9291 316.179 323.1766 316.0692 327.4185 309.8278 333.9161 315.5602 336.4446 315.3872 340.3306 315.3872 340.4004 316.8178"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "341.1661 310.6133 337.4831 308.7286 333.9148 308.3323 330.1217 303.1339 324.0083 306.8736 322.6206 306.8736 323.2264 305.6663 324.3826 305.5459 331.4051 300.6386 335.1538 306.8925 338.5451 306.1661 341.4921 309.8294 341.1661 310.6133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M345.6174,305.5391l-.3644-5.5271h-4.6584l.8974-1.6632s-3.8423-.2275-8.3895,.5875l-1.2532,.3187,8.4803-.3076-.823,1.6912h4.1797l.8851,5.4676,1.046-.5671Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "353.3924 302.2123 350.4181 306.188 349.3567 305.6258 351.4427 300.7817 351.1799 302.2123 352.2612 302.6082 353.3924 302.2123"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "357.5644 309.3021 353.5721 310.2836 353.1162 309.3021 356.9389 307.5188 356.1538 308.2208 356.5463 309.3853 357.5644 309.3021"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "351.4427 327.5607 351.9518 329.6866 349.7726 324.9656 350.9104 324.2303 354.1975 327.7503 352.6471 326.9585 351.4427 327.5607"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "356.2802 322.487 357.0155 323.0659 353.1162 321.4756 353.6951 320.2812 356.6495 321.0398 356.2802 322.487"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "358.4128 314.7384 358.4128 314.7418 357.5644 315.1011 357.5644 316.0692 354.5368 316.0692 354.5368 315.3872 358.4128 314.7384"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M354.5368,315.3872c0,5.6026-3.1806,10.1407-7.1031,10.1407s-7.1031-4.5381-7.1031-10.1407c0-.0965,0-.193,.0066-.2895,.1032-5.4662,3.2405-9.8512,7.0965-9.8512,3.9225,0,7.1031,4.5414,7.1031,10.1407Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M354.2841,315.3884c0,5.4007-3.0671,9.7788-6.8506,9.7788s-6.8505-4.3781-6.8505-9.7788,3.0671-9.7789,6.8505-9.7789,6.8506,4.3782,6.8506,9.7789Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M347.0416,315.5594c0,2.7291-1.5499,4.9415-3.4617,4.9415s-3.4617-2.2124-3.4617-4.9415,1.5498-4.9414,3.4617-4.9414,3.4617,2.2123,3.4617,4.9414Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M323.8353,297.3707s-5.4155,4.8571-5.5965,15.6938l12.3897-.6s4.3008-12.2581,13.9429-16.3803c-7.3937-.2143-14.519-.0725-20.7361,1.2865Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M344.5714,296.0842s7.0206,.7577,11.4288,3.6183c0,0,4.7133,6.8252,5.0737,17.9983h-1.8583s.0874-8.8997-4.6783-16.3854c0,0-3.6385-2.5507-9.9659-3.0501,0,0-8.8354,3.9121-11.8601,15.5263l-2.0828-1.3271s3.9558-12.684,13.9429-16.3803Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "318.2388 313.0645 320.3737 314.2907 332.7113 313.7916 330.6285 312.4645 318.2388 313.0645"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M342.0989,319.8209l2.2471,4.0086s3.9494,3.1294,7.6383-1.4406l-6.3669-2.8696s-1.046,1.2061-3.5185,.3016Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M354.5368,315.3872s-2.1658-1.8132-7.1031-2.0095c-4.7909-.1897-6.9734,1.6103-7.0965,1.72,.1032-5.4662,3.2405-9.8512,7.0965-9.8512,3.9225,0,7.1031,4.5414,7.1031,10.1407Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M287.3278,317.8308l-18.212-3.9183,4.8082-5.8079s11.1691-2.4955,13.4038,9.7262Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M287.3278,322.9325h-8.122l-3.1329-13.99s5.4639-.1361,7.5234,1.0344c2.0596,1.1706,4.19,9.1838,3.7315,12.9556Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M275.5397,321.2671c0,1.583-.2275,3.0893-.6418,4.4568-.0934,.3161-.1988,.625-.3138,.9268-.6705,1.7626-1.662,3.2426-2.8618,4.2796-.2682,.2346-.5484,.443-.8358,.6274-.9938,.6442-2.0954,1.001-3.2569,1.001-1.4298,0-2.7733-.5412-3.93-1.4919l.2994-.3593v-.3041l-1.1375-.1269c-.6826-.7376-1.2813-1.6309-1.765-2.6439l-.1102-.2491,.7376-.1078v-.5053l-.9723,.0767c-.4742-1.1879-.8023-2.5098-.946-3.9156l.6826-.2874v-.807l-.7568,.0694c-.0072-.2131-.012-.4239-.012-.6394,0-6.2361,3.542-11.2892,7.9102-11.2892s7.9101,5.0531,7.9101,11.2892Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M265.7523,332.2366s6.5067,1.9927,14.3252,.1861l.9182-22.0209s-7.6217-3.2142-15.2434-.1024v21.9372Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M282.1015,331.5577c.0024,0,.0048-.0024,.0096-.0048-.0024,.0048-.0048,.0072-.0096,.0072v-.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M286.1392,321.0611v.697h.6107c-.0383,1.2572-.2203,2.4594-.5221,3.5778-.0167,.0599-.0335,.1198-.0503,.1796l-.6969-.1796-.2658,1.0418,.5293,.4167c-.5125,1.3076-1.2046,2.4547-2.0285,3.3719l-1.1159-.57-.867,.4335,.3664,1.5303c-.9914,.6418-2.093,.9986-3.2522,.9986-4.3681,0-7.9101-5.0554-7.9101-11.2916s3.542-11.2892,7.9101-11.2892c1.0179,0,1.9925,.2754,2.8858,.7759l-.1892,1.0298,.7784,.285,.8142-.285c1.0489,.9651,1.9254,2.2751,2.5529,3.8197l-.5652,.5053,.2826,.8382,.7328-.0598c.3568,1.2117,.5724,2.5313,.6107,3.9131v.0024l-.6107,.2586Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M284.3519,321.268c0,4.34-2.4647,7.8583-5.5051,7.8583s-5.5052-3.5183-5.5052-7.8583,2.4648-7.8584,5.5052-7.8584,5.5051,3.5183,5.5051,7.8584Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "277.7071 328.3822 276.7874 332.1708 272.8623 332.1708 270.8865 331.5577 266.7507 330.2765 265.2778 331.3661 263.6996 331.0668 263.9991 330.7075 263.9991 330.4034 264.8587 330.4992 266.3866 328.9713 271.7223 330.9303 272.2541 331.1266 274.9242 331.0715 277.1634 328.1618 277.7071 328.3822"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "275.2475 326.2771 274.5841 326.6507 272.4264 327.8625 270.4674 327.9128 265.4287 325.379 263.6901 327.6326 261.0965 327.6326 260.9863 327.3835 261.7239 327.2757 261.7239 326.7704 263.0411 326.6675 265.2181 323.5829 270.4626 326.4328 271.8636 326.4567 274.8261 325.6089 274.8979 325.7239 275.2475 326.2771"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "273.7843 322.2969 270.9368 322.6849 269.1168 322.7447 264.3511 319.5404 261.9849 322.7447 259.8056 322.9315 260.4882 322.6441 260.4882 321.8371 261.3862 321.7581 264.4396 317.2653 269.1168 321.3916 270.9368 321.2671 273.7341 321.2671 273.7843 322.2969"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "274.3353 317.8308 271.6843 316.4741 269.1158 316.1889 266.3854 312.4469 261.9849 315.1389 260.9861 315.1389 261.4221 314.2698 262.2544 314.1832 267.3093 310.6508 270.0076 315.1525 272.4487 314.6296 274.5701 317.2665 274.3353 317.8308"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M277.5395,314.1783l-.2622-3.9785h-3.3533l.646-1.1973s-2.7658-.1637-6.0389,.423l-.9021,.2294,6.1043-.2215-.5924,1.2174h3.0086l.6371,3.9357,.7529-.4082Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "283.1361 311.7836 280.9951 314.6454 280.2312 314.2407 281.7327 310.7538 281.5435 311.7836 282.3219 312.0686 283.1361 311.7836"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "286.1392 316.887 283.2654 317.5934 282.9373 316.887 285.6891 315.6033 285.1238 316.1086 285.4064 316.9468 286.1392 316.887"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "281.7327 330.0298 282.0991 331.5601 280.5305 328.1618 281.3496 327.6326 283.7156 330.1663 282.5997 329.5963 281.7327 330.0298"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "285.2148 326.3777 285.7441 326.7944 282.9373 325.6497 283.3541 324.7899 285.4806 325.3359 285.2148 326.3777"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "286.7499 320.8001 286.7499 320.8025 286.1392 321.0611 286.1392 321.7581 283.9599 321.7581 283.9599 321.2671 286.7499 320.8001"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M283.9599,321.2671c0,4.0329-2.2894,7.2995-5.113,7.2995s-5.1129-3.2666-5.1129-7.2995c0-.0694,0-.1389,.0048-.2083,.0742-3.9348,2.3325-7.0911,5.1081-7.0911,2.8236,0,5.113,3.2689,5.113,7.2994Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M283.7779,321.268c0,3.8875-2.2077,7.039-4.9311,7.039s-4.9312-3.1515-4.9312-7.039,2.2078-7.039,4.9312-7.039,4.9311,3.1514,4.9311,7.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M278.5647,321.3911c0,1.9644-1.1156,3.5569-2.4918,3.5569s-2.4918-1.5925-2.4918-3.5569,1.1156-3.557,2.4918-3.557,2.4918,1.5925,2.4918,3.557Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M261.8604,308.2985s-3.8982,3.4962-4.0285,11.2967l8.9184-.4319s3.0957-8.8236,10.0363-11.7908c-5.3221-.1543-10.4511-.0522-14.9262,.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M276.7866,307.3725s5.0535,.5454,8.2267,2.6044c0,0,3.3927,4.913,3.6521,12.9556h-1.3376s.0629-6.4062-3.3675-11.7945c0,0-2.6191-1.8361-7.1737-2.1955,0,0-6.3599,2.8159-8.5371,11.1761l-1.4992-.9553s2.8474-9.1302,10.0363-11.7908Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "257.8319 319.5952 259.3686 320.4778 268.2495 320.1186 266.7503 319.1633 257.8319 319.5952"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M275.0068,324.4585l1.6175,2.8855s2.8429,2.2527,5.4983-1.037l-4.5831-2.0655s-.7529,.8681-2.5327,.217Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M283.9599,321.2671s-1.559-1.3052-5.113-1.4465c-3.4485-.1365-5.0195,1.1591-5.1081,1.2382,.0742-3.9348,2.3325-7.0911,5.1081-7.0911,2.8236,0,5.113,3.2689,5.113,7.2994Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "321.3251 279.226 322.8319 276.3648 343.1159 281.7148 342.5302 283.7842 321.3251 279.226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "343.1159 281.7148 350.6351 286.2987 350.3702 287.8886 342.5302 283.7842 343.1159 281.7148"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "308.0301 298.8043 308.3328 302.5452 310.2568 299.0969 308.0301 298.8043"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "323.7536 292.5822 329.2422 283.9885 330.2423 283.9885 325.3255 292.6044 323.7536 292.5822"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "330.2423 283.9885 338.8172 286.7252 338.9975 292.6898 338.7712 292.672 338.5449 286.8806 330.1321 284.1816 330.2423 283.9885"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "278.1731 291.8797 285.2168 299.5155 300.6693 299.9485 302.9313 292.5415 278.1731 291.8797"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "285.2168 299.5155 284.6582 300.1744 300.2339 300.7094 300.6693 299.9485 285.2168 299.5155"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "281.2435 288.2204 307.9218 288.751 324.8204 289.1624 328.3954 283.5305 316.5432 279.226 292.6371 279.226 281.2435 288.2204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "293.3433 279.226 291.6765 288.4279 295.8137 288.5102 315.8547 279.226 314.7771 279.226 295.5585 288.1805 292.2257 288.1405 293.8422 279.226 293.3433 279.226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "316.5432 279.226 307.9218 288.751 307.2729 288.7381 315.8547 279.226 316.5432 279.226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "293.3433 279.226 282.0861 288.2371 281.2435 288.2204 292.6371 279.226 293.3433 279.226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "321.3251 279.226 340.2544 292.6937 340.0556 286.273 321.3251 279.226"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "316.5432 270.9223 317.4921 253.2098 318.0871 253.4595 317.2971 268.1182 323.2053 268.4106 323.4382 269.7394 323.8041 269.8363 324.3751 258.3577 324.7041 258.3212 324.1557 271.1178 316.5432 270.9223"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "329.2422 272.2917 332.1525 250.3944 332.8421 250.3944 329.4173 272.3563 329.2422 272.2917"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M308.9269,289.1624s3.5745-.1325,5.7404,1.0086c0,0,.6773,1.1177-.0998,2.7924,0,0-1.6124,.8171-5.6406,.4516v-4.2526Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-111",
    cx: 308.9269,
    cy: 291.2887,
    rx: 0.9883,
    ry: 2.1263
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M309.5584,291.2887c0,.8801-.3317,1.5937-.7408,1.5937s-.7407-.7136-.7407-1.5937,.3316-1.5937,.7407-1.5937,.7408,.7135,.7408,1.5937Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M304.6631,299.3674c.0749,1.4202-.3995,2.5997-1.0596,2.6345s-1.2559-1.0883-1.3308-2.5084c-.0749-1.4202,.3995-2.5997,1.0596-2.6345s1.2559,1.0882,1.3308,2.5084Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M304.6614,299.3901c.0562,1.0645-.2994,1.9485-.7941,1.9746-.4948,.0261-.9414-.8156-.9975-1.8801-.0562-1.0644,.2994-1.9485,.7942-1.9746,.4947-.0261,.9413,.8157,.9974,1.8801Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M282.9431,298.6825c.3874,1.3684,.1859,2.6236-.4501,2.8037-.6361,.18-1.4657-.7833-1.8531-2.1516-.3874-1.3684-.1859-2.6236,.4502-2.8037,.636-.1801,1.4656,.7832,1.853,2.1516Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M282.9465,298.705c.2904,1.0257,.1393,1.9665-.3374,2.1014-.4767,.135-1.0985-.587-1.3889-1.6126-.2903-1.0256-.1393-1.9665,.3374-2.1014,.4767-.135,1.0986,.587,1.3889,1.6126Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "321.3251 279.226 339.6702 286.273 349.7726 287.8886 342.0938 283.7842 321.3251 279.226"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-106"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M314.0586,333.058c.0048,0,.0072-.0024,.0096-.0072-.0048,.0024-.0072,.0048-.0096,.0048v.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M351.9551,329.6866c.0066,0,.01-.0033,.0133-.01-.0067,.0033-.01,.0067-.0133,.0067v.0033Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M282.1015,331.5601c.0048,0,.0072-.0024,.0096-.0072-.0048,.0024-.0072,.0048-.0096,.0048v.0024Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M361.0739,317.7008c-.3604-11.1732-5.0737-17.9984-5.0737-17.9984-4.4082-2.8605-11.4288-3.6182-11.4288-3.6182-4.1009-.1188-8.1119-.1185-11.9385,.1286l.734-1.4122h0l6.2895-.5426,.598-1.5643-.1988-6.4207,9.717,1.3027-7.2424-3.7915,7.84,4.1043,.2649-1.5898-7.5192-4.5839-7.6015-2.0049-.9501-1.3731-1.7632-.2963-.897-4.7678-2.6526-.9775,.1659,.0611,3.4246-21.962h-.6895l-2.9103,21.8974-3.1856-1.1739-1.8996-.029,.5471-12.7676-.329,.0365-.571,11.4786-.3659-.0969-.2329-1.3288-5.9082-.2924,.7899-14.6587-.5949-.2497-.9489,17.7126,4.8295,.1239-9.6887-.1478-4.4111,4.9267h-10.328l-9.5601,7.547-6.1413,4.8482h0l-4.5842,3.6189,3.112,6.4981-3.8558,4.4722,1.7102,1.8502-1.9139,2.6885c-4.9357-.1089-9.679,.0382-13.8514,.9502,0,0-3.8982,3.4962-4.0284,11.2966l1.5367,.8827,.3792-.0153c-.0133,.2668-.0285,.5329-.0285,.8046,0,.2155,.0048,.4262,.012,.6394l.7568-.0695v.8071l-.6825,.2874c.1436,1.4058,.4717,2.7277,.9459,3.9155l.9723-.0766v.5053l-.7376,.1078,.1101,.2491c.4838,1.013,1.0825,1.9063,1.7651,2.6439l1.1375,.1269v.3041l-.2994,.3593c.6327,.52,1.3248,.9035,2.0527,1.1569v.0129s.215,.0648,.5987,.1585c.104,.0243,.2063,.0542,.3117,.0725,2.0409,.4656,7.3217,1.363,13.4148-.0449l.0007-.0165c.7081-.1588,1.3887-.4368,2.0209-.8461l-.3664-1.5303,.867-.4335,1.1159,.57c.8239-.9172,1.516-2.0644,2.0285-3.3719l-.5293-.4167,.2366-.9271c.3555,.5058,.7296,.9848,1.1299,1.4173l1.5803,.1763v.4226l-.4159,.499c.8798,.7231,1.8393,1.2683,2.8517,1.6204v.0047s.0374,.0114,.108,.0315c.4008,.1333,.8092,.2365,1.2254,.3051,.4729,.1067,1.0614,.2258,1.7571,.3464,.3435,.5494,.7195,1.0562,1.1306,1.5005l1.1376,.1269v.3041l-.2994,.3593c.6327,.52,1.3248,.9035,2.0527,1.1569v.0129s.2151,.0649,.5991,.1587c.1039,.0241,.2061,.0539,.3113,.0722,2.0408,.4656,7.3216,1.3631,13.4148-.0448l.0007-.0164c.7081-.1589,1.3887-.4369,2.0209-.8462l-.3664-1.5303,.8669-.4335,1.116,.57c.8238-.9172,1.516-2.0643,2.0285-3.3719l-.5293-.4167,.2658-1.0417,.6969,.1796c.0168-.0599,.0336-.1198,.0503-.1796,.2055-.7617,.3317-1.5732,.4186-2.4035h2.019c-.0867-2.6871-.5256-5.0149-1.0684-6.9367,.1142-.7997,.1884-1.6204,.214-2.4599h-.8484v-.9682l.6114-.2589,.8426,.4839,.5269-.0213c-.0184,.3708-.0396,.7405-.0396,1.1178,0,.2995,.0067,.5923,.0166,.8884l1.0514-.0965v1.1212l-.9482,.3993c.1996,1.9529,.6554,3.7894,1.3141,5.4396l1.3508-.1065v.702l-1.0247,.1497,.153,.346c.672,1.4073,1.5038,2.6483,2.452,3.673l1.5803,.1763v.4226l-.4159,.499c.8798,.7232,1.8394,1.2683,2.8518,1.6204v.0047s.0372,.0113,.1076,.0314c.4009,.1332,.8096,.2366,1.2259,.3052,2.8851,.651,10.1717,1.862,18.5675-.0779l.001-.0228c.9838-.2207,1.9293-.607,2.8076-1.1756l-.5091-2.1259,1.2044-.6022,1.5504,.7918c1.1445-1.2742,2.106-2.8679,2.8179-4.6845l-.7352-.5788,.3693-1.4473,.9681,.2496,.0699-.2496c.2864-1.0617,.4883-2.1812,.6088-3.3389h2.7776Zm-74.8012-15.5128c-.6217,.7226-1.1824,1.5444-1.6804,2.4418l-.0106,.001-.2272,.4527c-.1097,.213-.2211,.4233-.3233,.6443l-.0554,.1104h.0085c-.4341,.9556-.7922,1.9847-1.0738,3.0686-.4042-.1645-.8133-.3154-1.2196-.4489l4.1049-6.2839,.4769,.014Zm32.4302,6.0964l-.8013,.0654-.3926-1.1644,.7852-.702c-.393-.9672-.8652-1.8569-1.3889-2.6776l.3539-1.0368h.6084l.4795-.6159,2.3037-.0929c-.7727,1.6241-1.4961,3.6969-1.9479,6.2242Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 302.996,
    cy: 299.2503,
    rx: 13.2319,
    ry: 8.0066
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M310.6999,299.2503c0,2.5745-3.4491,4.6616-7.7039,4.6616s-7.7039-2.0871-7.7039-4.6616,3.4491-4.6617,7.7039-4.6617,7.7039,2.0871,7.7039,4.6617Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 282.1231,
    cy: 298.6683,
    rx: 13.2319,
    ry: 8.0066
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M289.8271,298.6683c0,2.5746-3.4492,4.6617-7.7039,4.6617s-7.7039-2.0871-7.7039-4.6617,3.4491-4.6616,7.7039-4.6616,7.7039,2.0871,7.7039,4.6616Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 308.9847,
    cy: 291.3334,
    rx: 9.5327,
    ry: 5.7682
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M314.5348,291.3334c0,1.8548-2.4849,3.3584-5.5501,3.3584s-5.5502-1.5036-5.5502-3.3584,2.4849-3.3584,5.5502-3.3584,5.5501,1.5036,5.5501,3.3584Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M303.6613,334.6335s20.0185-10.6812,25.9327-11.0838c5.9143-.4025-.1905,5.6426,1.8111,6.0466,2.0017,.4041-.8551-9.1124,39.2875-19.5065,40.1426-10.394,62.1997,13.758,65.832,23.6444l-133.9138,.9438,1.0505-.0445Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.6613,334.6335s9.2314-6.8388,27.1284-3.5595c17.897,3.2792,26.6406-19.2008,51.3205-19.8324,24.68-.6316,29.5848,22.6676,29.5848,22.6676l-108.0337,.7243Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColony);
export default __webpack_public_path__ + "static/media/colony.2edd6e8aecb5ffaab403d140f5a0cea2.svg";
export { ForwardRef as ReactComponent };